<template lang="pug">
  #ContactsIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 櫃點統計報表
    .container-width
      b-form-group.mx-3.mt-3.mb-3.text-gray(
        label="日期區間"
      )
        .d-flex.align-items-center
          b-input(
            v-model="searchInput.start_date"
            type="date",
            placeholder="開始區間",
            style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
          )
          p.mb-0.text-center(
            style="flex-grow: 0.5!important;"
          ) -
          b-input(
            v-model="searchInput.end_date"
            type="date",
            placeholder="結束區間",
            style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
          )
      .row.no-gutters.mx-3
        .col-6.pr-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="resetHandler();",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 重置
        .col-6.pl-2
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="searchHandler()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.15rem 0.15rem 0 #00000033;"
          ) 搜尋
      .p-3
        .overflow-auto.text-center(
          style="word-break: keep-all; max-height: calc(100vh - 15rem);"
        )
          table.table
            thead.bg-black.text-white
              tr
                th(scope='col', style="left: 0; top:0; background-color: #000; z-index: 2" v-for="header in byCounterReports.header") {{ header }}
            tbody(
              v-if="byCounterReports.report && byCounterReports.report.length > 0"
            )
              tr(
                v-for="(report, index) in byCounterReports.report",
                style="white-space: nowrap;"
              )
                th(scope='row' v-for="item in report") {{ item }}
            tbody(
              v-else
            )
              tr
                td.text-center(
                  colspan="9487"
                ) 暫無報表資料
</template>

<script>
import { mapState } from 'vuex';

const moment = require('moment');

export default {
  name: 'ByCounterReportIndex',
  data() {
    return {
      searchInput: {
        start_date: null,
        end_date: null,
      }
    };
  },
  created() {
    const vm = this;
    vm.resetHandler();
    // vm.$swal.fire({
    //   title: '載入中，請稍候',
    //   allowOutsideClick: false,
    //   willOpen: () => {
    //     this.$swal.showLoading();
    //   }
    // });
    // // 取得個人資料
    // vm.$store.dispatch('sic_district_reports/getReservationReportHandler')
    //   .then(() => {
    //     vm.$swal.close();
    //     vm.$store.commit('toggleLoading', false);
    //   });
  },
  computed: {
    ...mapState({
      byCounterReports: (state) => state.sic_by_counter_reports.byCounterReports,
    })
  },
  methods: {
    // 搜尋
    searchHandler() {
      const vm = this;
      if ((vm.searchInput.start_date && !vm.searchInput.end_date) || (!vm.searchInput.start_date && vm.searchInput.end_date)) {
        vm.$swal.fire({
          icon: 'error',
          title: '日期區間尚未選擇完全'
        });
      } else {

        if (vm.searchInput.start_date && vm.searchInput.end_date) {
          const startDateFormat = moment(vm.searchInput.start_date);
          const endDateFormat = moment(vm.searchInput.end_date);
          if (endDateFormat.isBefore(startDateFormat)) {
            vm.$swal.fire({
              icon: 'error',
              title: '日期區間結束時間不可小於開始時間'
            });
            return;
          }
        }
        vm.infiniteHandler();
      }
    },
    // 重置
    resetHandler() {
      const vm = this;
      vm.$store.commit('sic_by_counter_reports/resetHandler');
      vm.searchInput = {
        start_date: null,
        end_date: null
      };
    },
    infiniteHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 取得by counter統計報表
      vm.$store.dispatch('sic_by_counter_reports/getByCounterReportHandler', vm.searchInput)
        .then(() => {
          vm.$swal.close();
        });
    }
  },
};
</script>

<style lang="scss" scoped>
  tbody tr:nth-child(even) th {
    background-color: #eee;
  }
  tbody tr:nth-child(odd) th {
    background-color: #fff;
  }
  .table {
    max-height: calc(100vh - 10rem);
  }
</style>
